@if (errorMessage) {
    <kui-alert type="danger" class="key-alert-wrapper">
        <kui-icon name="ban" size="sm"></kui-icon>
        <span>{{ errorMessage }}</span>
    </kui-alert>
}
@if (asset) {
    <div class="contacts p-3">
        <h4>{{ asset.name }}</h4>
        @if (!(contacts && contacts.length)) {
            <div class="no-contacts pt-3 pb-3">
                {{ "SHARED.CONTACTS.NO_CONTACTS" | translate }}
            </div>
        }
        <key-contacts [contacts]="contacts"></key-contacts>
    </div>
}
